import { render, staticRenderFns } from "./feifang.vue?vue&type=template&id=196851c7&scoped=true"
import script from "./feifang.vue?vue&type=script&lang=js"
export * from "./feifang.vue?vue&type=script&lang=js"
import style0 from "./feifang.vue?vue&type=style&index=0&id=196851c7&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "196851c7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/publish/iot-cloud-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('196851c7')) {
      api.createRecord('196851c7', component.options)
    } else {
      api.reload('196851c7', component.options)
    }
    module.hot.accept("./feifang.vue?vue&type=template&id=196851c7&scoped=true", function () {
      api.rerender('196851c7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/messagejk/feifang.vue"
export default component.exports